import { useMemo } from 'react';

import { InvestmentPaths, MoneyTransferStatus, TransactionStatus } from '../../investments.types';
import { useInvestorQuery } from '../../queries';
import { useInitiatedTransactionsQuery, useTransactionsHistoryQuery } from '../InvestmentActivities/queries';

const TRANSACTIONS_PER_PAGE = 20;
const useInvestmentsProcessing = () => {
  const { data: investor } = useInvestorQuery();
  const { data: transactionHistory } = useTransactionsHistoryQuery({
    page: 1,
    perPage: TRANSACTIONS_PER_PAGE,
    startDate: null,
    endDate: null,
    funds: [],
  });

  const { total: totalInitiatedTransactions } = useInitiatedTransactionsQuery({
    statuses: [MoneyTransferStatus.CreatedExternal, MoneyTransferStatus.CreatedInternal],
    isStandAloneMode: true,
    perPage: 1,
    startDate: null,
    endDate: null,
  });
  const isProcessingSelfDirectedPresented = useMemo(() => {
    if (investor.type !== InvestmentPaths.SELF_DIRECTED) {
      return true;
    }
    const isProcessingItemPresent = transactionHistory.some(
      (item) => item.status === TransactionStatus.New || item.status === TransactionStatus.Filled
    );

    return isProcessingItemPresent;
  }, [investor.type, transactionHistory]);
  const isProcessingManagedPresented = useMemo(() => {
    if (investor.type !== InvestmentPaths.MANAGED) {
      return true;
    }
    return !!totalInitiatedTransactions;
  }, [investor.type, totalInitiatedTransactions]);

  const isManagedOrSelfDirected = useMemo(() => {
    return investor.type === InvestmentPaths.MANAGED || investor.type === InvestmentPaths.SELF_DIRECTED;
  }, [investor.type]);
  const isApplied = useMemo(() => {
    return (
      investor.isInvestmentModelSwitching === false &&
      investor.isFullLiquidationInProgress === false &&
      !investor.balance &&
      isProcessingSelfDirectedPresented &&
      isProcessingManagedPresented &&
      isManagedOrSelfDirected
    );
  }, [
    investor.isInvestmentModelSwitching,
    investor.isFullLiquidationInProgress,
    investor.balance,
    isProcessingSelfDirectedPresented,
    isProcessingManagedPresented,
    isManagedOrSelfDirected,
  ]);
  return isApplied;
};

export default useInvestmentsProcessing;
